<header>
  <div class="header">
      <button mat-button [matMenuTriggerFor]="panel.menu">
        <mat-icon>menu</mat-icon>
      </button>
      <app-menu-panel #panel [items]="menuItems"></app-menu-panel>
      <!-- <button mat-button >
        <mat-icon>search-button</mat-icon>
      </button> -->
    <div class="logo-side">
      <a routerLink="/dashboard">
        <img class="logo" [src]="'assets/images/logo2.png' | baseUrl" alt="Logo Sequoia">
      </a>
      <form [formGroup]="searchForm">
        <div class="input-search">
          <input formControlName="search" type="text" placeholder="Localizar menu..." class="search-input">
          <button class="search-button" (click)="abrirModalPesquisa(menuItems)">
            <mat-icon>search</mat-icon>
          </button>
        </div>   
      </form>
    </div>
    <div class="sugestao-usuario">
      <div class="sugestoes">  
        <button *ngIf="habilitarInclusao" (click)="abrirModalSugestoes()" mat-flat-button style="background-color: #2f3333; color: white">
          <i style="color: #d7df23;" class="far fa-lightbulb mr-1"></i>
          Sugestões
          <small class="card-number-sugestoes ml-1">{{sugestoesTotais == 0 || sugestoesTotais == undefined || sugestoesTotais == null? '0' : sugestoesTotais }}</small>
        </button>
      </div>
      <div class="user-side" *ngIf="usuario">
        <div class="user-side--content">
          <button mat-button [matMenuTriggerFor]="menuUser">
            <div class="menu-user">
              <div class="photo">
                <img [src]="'assets/images/user.jpg' | baseUrl" alt="Foto">
              </div>

              <p class="name" >{{ usuario.nome }}<br />
                <small>{{ usuario.descricao }}</small>
              </p>

              <i class="fas fa-chevron-down"></i>
            </div>
          </button>
          <mat-menu #menuUser="matMenu" xPosition="before">
            <button *ngIf="habilitarInclusao" class="user-content-button" (click)="abrirModalSugestoes()" mat-menu-item>
              <i class="far fa-lightbulb"></i>
              Sugestões
              <span class="badge badge-pill badge-primary">{{sugestoesTotais == 0 || sugestoesTotais == undefined || sugestoesTotais == null? '0' : sugestoesTotais }}</span>
            </button>
            <button class="user-content-button" (click)="abrirModalPerfil()" mat-menu-item>
              <i class="fas fa-user"></i>
              Perfil
            </button>
            <button class="user-content-button" (click)="logout()" mat-menu-item>
              <i class="fas fa-sign-out-alt"></i>
              Sair
            </button>
          </mat-menu>
        </div>
      </div>

    </div>
  </div>
</header>
